import ClipboardJS from "clipboard";
import * as cheerio from "cheerio";
/* -------------------------------------------------------------------------- */
/*                                   TOOLBAR                                  */
/* -------------------------------------------------------------------------- */
function handle_toolbar() {
  const toolbar = document.querySelector(".nl_module-toolbar");
  const toggleBtn = document.querySelector(".toggle-display-code");
  if (!toolbar || !toggleBtn) return;
  toggleBtn.addEventListener("click", function(e) {
    e.preventDefault();
    let display_code = toolbar.dataset.displayCode;

    if (display_code === "show") {
      toolbar.dataset.displayCode = "hide";
    } else {
      toolbar.dataset.displayCode = "show";
    }
  });

  // Init clipboard
  const clipboard = new ClipboardJS(".btn-copy-code");

  clipboard.on("success", function(e) {
    e.trigger.classList.add("success");

    setTimeout(() => {
      e.trigger.classList.remove("success");
    }, 400);
  });
}

/* -------------------------------------------------------------------------- */
/*                               HANDLE HOSTNAME                              */
/* -------------------------------------------------------------------------- */
function handle_hostname() {
  const host = window.location.origin;

  function handle_attr(type) {
    const items = Array.from(document.querySelectorAll(`[${type}]`));

    items.map((item) => {
      let url = item.getAttribute(type);
      if (url.startsWith("/")) {
        url = host + url;
        item.setAttribute(type, url);
      }
    });
  }

  handle_attr("href");
  handle_attr("src");
}

/* -------------------------------------------------------------------------- */
/*                                 SET CONTENT                                */
/* -------------------------------------------------------------------------- */
// Transforme la couleur du lien (rendu navigateur / computedStyle) en attribut html pour garantir son rendu en email
// -> fix par exemple les "color:inerit;"
function set_links_color() {
  const links = document.querySelectorAll("a:not(.nl-btn)");
  links.forEach((link) => {
    const color = window.getComputedStyle(link).getPropertyValue("color");
    link.style.color = color;
  });
}

// Rempli l'attribut width des images en fonction de leur taille générée via css (computedStyle)
function set_images_width() {
  const images = document.querySelectorAll("img");
  images.forEach((img) => {
    let width = parseInt(
      window.getComputedStyle(img).getPropertyValue("width")
    );
    img.setAttribute("width", width);
  });
}

// Ajoute une classe sur les rows si leur couleur de fond est la même que le row précédent
function check_rows_bgColor() {
  const rows = document.querySelectorAll(".block-system-main-block > .row");
  let last_bgColor = null;
  rows.forEach((row) => {
    const bgColor = window
      .getComputedStyle(row)
      .getPropertyValue("background-color");
    if (bgColor === last_bgColor) {
      row.classList.add("same-bg-as-previous-row");
    }
    last_bgColor = bgColor;
  });
}

/* -------------------------------------------------------------------------- */
/*                                GENERATE BTN                                */
/* -------------------------------------------------------------------------- */
function generate_btn() {
  const buttons = document.querySelectorAll("[data-btn], .js-nl-btn");

  buttons.forEach((btn) => {
    const computed_style = window.getComputedStyle(btn);
    const link_url = btn.href;
    const btn_style = {
      width: computed_style.getPropertyValue("width"),
      height: computed_style.getPropertyValue("height"),
      bgColor: computed_style.getPropertyValue("background-color"),
      color: computed_style.getPropertyValue("color"),
      fontFamily: computed_style.getPropertyValue("font-family"),
      fontSize: computed_style.getPropertyValue("font-size"),
    };

    const textAlign = window
      .getComputedStyle(btn.parentNode)
      .getPropertyValue("text-align");

    const btn_outout = `
    <table border="0" cellpadding="0" cellspacing="0" 
        class="content-btn-table mso-table" 
        role="presentation" 
        width="100%">
      <tr>
        <td class="content-btn-td">
          <div style="text-align: ${textAlign}">
            <!--[if mso]>
            <a:roundrect href="${link_url}" xmlns:a="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word"
              style="height:${btn_style.height};width:${btn_style.width};v-text-anchor:middle;text-decoration:none !important; text-decoration:none;" arcsize="10%" stroke="false" fillcolor="${btn_style.bgColor}">
              <w:anchorlock/>
              <v:textbox inset="0px,0px,0px,0px">
                <center style="color:${btn_style.color}; font-family:${btn_style.fontFamily}; font-size::${btn_style.fontSize};text-decoration:none !important; text-decoration:none;">
                  <![endif]-->
                    ${btn.outerHTML}
                  <!--[if mso]>
                </center>
              </v:textbox>
            </a:roundrect>
            <![endif]-->
            
          </div>
        </td>
      </tr>
    </table>
    
    `;

    // Remplace le button part la nouvelle structure
    btn.outerHTML = btn_outout;
  });
}

/* -------------------------------------------------------------------------- */
/*                               GALLERY PHOTOS                               */
/* -------------------------------------------------------------------------- */
function set_gallery_photos_items_size() {
  const items = document.querySelectorAll("[data-set-item-size]");
  items.forEach((item) => {
    // get item size
    const item_width = parseInt(
      window.getComputedStyle(item).getPropertyValue("width")
    );

    // LE RATIO est communiqué via twig
    const ratio = item.getAttribute("data-ratio");
    let ratio_operator = 9 / 16;
    switch (ratio) {
      case "1x1":
        ratio_operator = 1;
        break;
      case "4x3":
        ratio_operator = 3 / 4;
        break;
      case "3x2":
        ratio_operator = 2 / 3;
        break;
      case "a4":
        ratio_operator = 29.7 / 21;
        break;
      case "4x3":
        ratio_operator = 3 / 4;
        break;
      default:
        ratio_operator = 9 / 16;
        break;
    }

    // SET LA HAUTEUR
    item.setAttribute("height", item_width * ratio_operator);

    const item_height = parseInt(
      window.getComputedStyle(item).getPropertyValue("height")
    );

    // set item size
    if (item.getAttribute("width") == "**ITEM_WIDTH**")
      item.setAttribute("width", item_width);
    if (item.getAttribute("height") == "**ITEM_HEIGHT**")
      item.setAttribute("height", item_height);

    // set item mso size
    const regex_width = /\*\*ITEM_WIDTH\*\*/g;
    const regex_height = /\*\*ITEM_HEIGHT\*\*/g;
    item.innerHTML = item.innerHTML.replace(regex_width, item_width);
    item.innerHTML = item.innerHTML.replace(regex_height, item_height);

    // set item content size
    const item_content = item.querySelector(".nl-gallery-item-content");
    const computed_style = window.getComputedStyle(item_content);
    const item_content_rect = {
      paddingTop: parseInt(computed_style.getPropertyValue("padding-top")),
      paddingLeft: parseInt(computed_style.getPropertyValue("padding-left")),
      paddingRight: parseInt(computed_style.getPropertyValue("padding-right")),
      paddingBottom: parseInt(
        computed_style.getPropertyValue("padding-bottom")
      ),
    };
    item_content.setAttribute(
      "width",
      item_width -
        (item_content_rect.paddingLeft + item_content_rect.paddingRight)
    );
    item_content.setAttribute(
      "height",
      item_height -
        (item_content_rect.paddingTop + item_content_rect.paddingBottom)
    );
  });
}

/* -------------------------------------------------------------------------- */
/*                                   INLINE                                   */
/* -------------------------------------------------------------------------- */
function get_content_to_inline() {
  // Clone HTML
  let clone_html = document.querySelector("html").cloneNode(true);
  // Remove elements to ignore
  const elements_to_remove = clone_html.querySelectorAll(
    "[data-ignore], script"
  );
  elements_to_remove.forEach((element) => element.remove());
  return clone_html.outerHTML;
}

function get_doctype() {
  const node = document.doctype;
  const doctype =
    "<!DOCTYPE " +
    node.name +
    (node.publicId ? ' PUBLIC "' + node.publicId + '"' : "") +
    (!node.publicId && node.systemId ? " SYSTEM" : "") +
    (node.systemId ? ' "' + node.systemId + '"' : "") +
    ">";
  return doctype;
}

function getCssVariables() {
  let names = [];
  let stylesheets = Array.from(document.styleSheets);
  for (let stylesheet of stylesheets) {
    try {
      let rules = stylesheet?.cssRules;
      for (let rule of rules) {
        if (!rule.style) continue;
        for (let name of rule.style) {
          if (names.includes(name) || name.indexOf("--") !== 0) continue;
          names.push(name);
        }
      }
    } catch (e) {}
  }
  let style = window.getComputedStyle(document.documentElement);
  let result = {};

  names.forEach((name) => (result[name] = style.getPropertyValue(name)));
  return result;
}

/* -------------------------------------------------------------------------- */
/*                               INLINE CSS VAR                               */
/* -------------------------------------------------------------------------- */
const variableDefRegex = /^(--[a-zA-Z0-9-_]+)$/;
const variableUsageRegex = /var\((--[a-zA-Z0-9-_]+)(?:\)|,\s*(.*)\))/;
/**
 * Resolves any variable usages found in a style value to their definitions.
 */
function resolveCSSVariables(defs, styleValue) {
  if (styleValue === void 0) {
    styleValue = "";
  }
  var match;
  while ((match = styleValue.match(variableUsageRegex))) {
    var found = match[0],
      variableName = match[1],
      fallback = match[2];
    var index = match.index;
    var before = styleValue.slice(0, index);
    var after = styleValue.slice(index + found.length);
    var replacement = defs.has(variableName)
      ? defs.get(variableName)
      : fallback;
    styleValue = ""
      .concat(before)
      .concat(resolveCSSVariables(defs, replacement || ""))
      .concat(after);
  }
  return styleValue;
}
/**
 * Walks the tree depth-first,
 * collecting variable definitions and then resolving any usages found.
 */
function replaceCSSVariables($, $el, defs) {
  if (defs === void 0) {
    defs = new Map();
  }
  var styles = $el.css();
  if (styles) {
    /**
     * Collect the defs first.
     */
    Object.entries(styles).forEach(function(_a) {
      var key = _a[0],
        value = _a[1];
      if (variableDefRegex.test(key)) {
        defs.set(key, value);
      }
    });
    /**
     * Resolve any usages.
     * Done separately from above in case any defs and usages are found on the same element.
     */
    Object.entries(styles).forEach(function(_a) {
      var key = _a[0],
        value = _a[1];
      styles[key] = resolveCSSVariables(defs, value);
    });
    $el.css(styles);
  }
  $el.children().each(function(index, el) {
    return replaceCSSVariables($, $(el), new Map(defs));
  });
}

function inlineWithVariablesReplaced(html) {
  const juice = require("juice");
  var inlined = juice(html);
  var $ = cheerio.load(inlined);
  var $root = $.root();
  replaceCSSVariables($, $root);
  return $.html();
}

/* -------------------------------------------------------------------------- */
/*                                   INLINE                                   */
/* -------------------------------------------------------------------------- */
function inline_css() {
  // const juice = require('juice');
  // Récupère les variables CSS
  // const css_variables = getCssVariables();
  // Récupère le Doctype
  const doctype = get_doctype();
  // Récupère le HTML
  const content_to_inline = get_content_to_inline();

  let result = inlineWithVariablesReplaced(content_to_inline);
  // let regexp = /var\(--.*?\)/g;
  // let matches = result.match(regexp);
  // matches?.forEach(match => {
  //   let variableName = match.replace('var(', '').replace(')', '');
  //   if (css_variables[variableName]) {
  //     result = result.replace(match, css_variables[variableName]);
  //   }
  // });
  const textarea_copyCode = document.querySelector("#copy_code");
  if (textarea_copyCode) {
    document.querySelector("#copy_code").value = doctype + result;
  }
}

/* -------------------------------------------------------------------------- */
/*                                   HANDLES                                  */
/* -------------------------------------------------------------------------- */
function on_content_fully_loaded() {
  set_images_width();
  handle_hostname();
  inline_css();
}

// const tld = window.location.origin.split('.').pop();
// if(tld=='test'){
//   let bgs = document.querySelectorAll(".nl-gallery-item");
//   bgs.forEach(bg => {
//     bg.setAttribute('background', 'https://picsum.photos/800/600?grayscale');
//     bg.style.backgroundImage = "url('https://picsum.photos/800/600?grayscale')";
//   });
//   let imgs = document.querySelectorAll("img");
//   imgs.forEach(img => {
//     img.src = 'https://picsum.photos/800/600?grayscale';
//   });
// }

/* -------------------------------------------------------------------------- */
/*                                    INIT                                    */
/* -------------------------------------------------------------------------- */
handle_toolbar();
set_links_color();
check_rows_bgColor();
generate_btn();
set_gallery_photos_items_size();
window.addEventListener("load", on_content_fully_loaded);
